// Generated by scripts/build-ui-icons.mjs.
export { CookingPot as default } from "../ui/glyphs-3";
